import { TypeEntite } from './typeEntite';

export class TypeEntiteResponse {
  typeEntite: TypeEntite;
  httpStatusCode: number;
  // Distingue les deux causes d'un typeEntite absent : entreprise inconnue de l'annuaire G2B (false)
  // ou entreprise connue dont le type d'entité n'est pas exploitable (true). Les deux cas n'ont pas le
  // même traitement en IHM, cf. TypeAdresseTEMPOSTComponent.verifierSiret().
  entrepriseTrouvee: boolean;
}
